<template>
  <div id="noon-report-list">
    <nprogress-container></nprogress-container>
    <!-- アドオンが読み込まれていない場合は何も表示しない -->
    <div v-if="!hasAddon"></div>
    <!-- メイン -->
    <div v-else class="vx-card p-8 noon-report-contents">
      <report-list-header ref="ReportListHeader" @clickButton="print"/>
      <report-list-body ref="ReportListBody"/>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/authService";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

import ReportListHeader from "./header/ReportListHeader";
import ReportListBody from "./body/ReportListBody";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations } = createNamespacedHelpers("vesselNoonReportList");

import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    ReportListHeader,
    ReportListBody,
    NprogressContainer
  },
  data(){
    return {
      hasAddon: false,
    }
  },
  methods: {
    ...mapActions(["getReportSetting", "resetState"]),

    print () {
      window.print();
    },
  },
  async created(){
    this.hasAddon = await AuthService.hasAddon(AuthService.ADDON_IDS.VESSEL_NOON_REPORT);
    if(!this.hasAddon) return;

    await this.getReportSetting();
  },
  mounted(){
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
  },

  destroyed () {
    this.resetState();
    this.$nprogress.done(true);
    this.$nprogress.remove()
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";


#noon-report-list {
  --vs-primary: 3, 155, 229;
  font-family: $aisea-font-family;

  .noon-report-contents {
    height: 100vh;
    box-sizing: border-box;
  }
}

</style>
